var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52481 3.82505C7.52481 3.68581 7.46949 3.55227 7.37104 3.45382C7.27258 3.35536 7.13904 3.30005 6.9998 3.30005C6.86057 3.30005 6.72703 3.35536 6.62857 3.45382C6.53012 3.55227 6.4748 3.68581 6.4748 3.82505V6.97505H3.3248C3.18557 6.97505 3.05203 7.03036 2.95357 7.12882C2.85512 7.22727 2.7998 7.36081 2.7998 7.50005C2.7998 7.63929 2.85512 7.77282 2.95357 7.87128C3.05203 7.96974 3.18557 8.02505 3.3248 8.02505H6.4748V11.175C6.4748 11.3143 6.53012 11.4478 6.62857 11.5463C6.72703 11.6447 6.86057 11.7 6.9998 11.7C7.13904 11.7 7.27258 11.6447 7.37104 11.5463C7.46949 11.4478 7.52481 11.3143 7.52481 11.175V8.02505H10.6748C10.814 8.02505 10.9476 7.96974 11.046 7.87128C11.1445 7.77282 11.1998 7.63929 11.1998 7.50005C11.1998 7.36081 11.1445 7.22727 11.046 7.12882C10.9476 7.03036 10.814 6.97505 10.6748 6.97505H7.52481V3.82505Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayPlusIcon);
export default __webpack_public_path__ + "static/media/grayPlusIcon.67e117c42d5a911a06f12b8f0e01d1eb.svg";
export { ForwardRef as ReactComponent };